module.exports = __webpack_public_path__ + "img/WorkSans-Regular.a67f6a0.svg";